import React from "react";
import { ContentCard } from "../../components/ContentCard";
import { ComparableForReview } from "common/types/common.types";
import {
  extendedFilters,
  getComparableFilterTypeTranslated,
  getFilterValues,
  otherFilters,
} from "../../helpers/comparableFilters.helpers";
import { SavedComparableFilter } from "../../types/api.types";
import { CenteredContentWrapper } from "../../components/wrappers/CenteredContentWrapper";
import { useTranslation } from "react-i18next";
import { MyProperty } from "common/types/common.types";
import { SimilarityTable } from "../../components/tables/SimilarityTable";
import { Chip } from "@mui/material";

interface TransparencySimilarityProps {
  comparablesForReview: ComparableForReview[];
  appliedFilters?: SavedComparableFilter[];
  property: MyProperty;
  readonly?: boolean;
  title?: string;
}

export const TransparencySimilarity: React.FC<TransparencySimilarityProps> = ({
  comparablesForReview,
  appliedFilters,
  property,
  readonly = false,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <ContentCard title={title ?? t("transparency.comparableSelection")}>
      <div style={{ marginBottom: "20px" }}>
        <div style={{ marginBottom: "10px" }}>
          {t("transparency.candidatesSelectedByFilters")}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          {appliedFilters?.map((f) => {
            if (
              otherFilters.includes(f.type) ||
              extendedFilters.includes(f.type)
            ) {
              return null;
            }
            return (
              <Chip
                key={f.type}
                label={`${getComparableFilterTypeTranslated(
                  f.type
                )}: ${getFilterValues(f)}`}
                variant="outlined"
              />
            );
          })}
        </div>
      </div>
      <SimilarityTable
        comparables={comparablesForReview}
        property={property}
        showStatus={true}
        enableGrouping={true}
        readonly={readonly}
      />
    </ContentCard>
  );
};
